module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control margin-bottom",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.item.name,
      "type": _vm.item.type,
      "placeholder": _vm.item.placeholder,
      "name": _vm.item.name,
      "disabled": _vm.item.disabled,
      "multiple": "multiple"
    },
    on: {
      "change": _vm.update
    }
  }), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('button', {
    on: {
      "click": _vm.click
    }
  }, [_vm._v("Seleccionar archivos")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      staticClass: "to-up",
      class: {
        'margin-left': _vm.item.type == 'checkbox'
      },
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n            " + _vm._s(error) + "\n        ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.item.value !== null && _vm.item.value.length > 0) ? _c('div', {
    staticClass: "container-fluid table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('th', [_vm._v("Tamaño")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Tipo de adjunto")]), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('th', [_vm._v("Progreso")]) : _vm._e(), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('th', [_vm._v("Eliminar")]) : _vm._e(), _vm._v(" "), (_vm.item.downloadOnly) ? _c('th', [_vm._v("Descargar")]) : _vm._e()]), _vm._v(" "), _c('tbody', _vm._l((_vm.item.value), function(file, key) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('td', [_vm._v(_vm._s(file.sizeMB))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(file.type))]), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('td', [_c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress-bar progress-bar-success",
      style: ({
        width: file.ready + '%'
      }),
      attrs: {
        "role": "progressbar"
      }
    })])]) : _vm._e(), _vm._v(" "), (!_vm.item.downloadOnly) ? _c('td', {
      on: {
        "click": function($event) {
          _vm.remove(key)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-trash"
    })]) : _vm._e(), _vm._v(" "), (_vm.item.downloadOnly) ? _c('td', [_c('a', {
      attrs: {
        "href": file.link
      }
    }, [_vm._v("enlace")])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    class: _vm.className
  }, [_c('br'), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "file-text"
    }
  }, [_vm._v("Este campo permite adjuntar varios archivos siempre y cuando la suma de todos no superen 20MB, se permitirán las siguientes extensiones: PDF, XLS, XLSX, DOC o DOCX.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-105e22f9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input-components/emt-file.vue
// module id = 192
// module chunks = 0